import { useMemo } from 'react'
import { useTranslation } from 'next-i18next'
import { ESTATE_COST_CALCULATION_TYPES, REAL_ESTATE_OPERATION_TYPES } from '@constants/definition'
import { numberWithSpaces } from '@utils/formatNumbers'

const useObjectPrice = (operation, price, currency, currentCurrency = null, costCalculation) => {
  const { t } = useTranslation(['object'])

  const format = useMemo(() => {
    if (!operation || !currency || !price) {
      return null
    }

    const calcPrice =
      currentCurrency === null ? price : Math.ceil((price * currency.rate) / currentCurrency.rate)
    const symbol = currentCurrency === null ? currency.symbol : currentCurrency.symbol

    const priceParams = {
      price: numberWithSpaces(calcPrice),
      currency: symbol,
    }

    if (costCalculation === ESTATE_COST_CALCULATION_TYPES.METER) {
      return t('object::priceFormatMeter', priceParams)
    } else if (costCalculation === ESTATE_COST_CALCULATION_TYPES.TEN_METERS) {
      return t('object::priceFormatTenMeter', priceParams)
    } else {
      switch (operation) {
        case REAL_ESTATE_OPERATION_TYPES.RENT_OUT:
          return t('object::priceFormat::rentOut', priceParams)

        case REAL_ESTATE_OPERATION_TYPES.DAILY:
          return t('object::priceFormat::daily', priceParams)

        case REAL_ESTATE_OPERATION_TYPES.SELLING:
        default:
          return t('object::priceFormat::selling', priceParams)
      }
    }
  }, [operation, price, currency, t, currentCurrency, costCalculation])

  return format
}

export default useObjectPrice
